import React from 'react';
import { THEME } from 'static/Theme';

/**
 * Context supports dynamic theme
 */
export const ThemeContext = React.createContext({
  theme: THEME.LIGHT,
  toggleTheme: () => {},
});
